import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useMediaQuery from 'hooks/useMediaQuery';
import useScrollPosition from 'hooks/useScrollPosition';

import { sendEvent } from 'lib/gtag';
import { scrollToTop } from 'lib/utils';

import { SCROLL_TO_TOP_CSS_VAR, SCROLL_TO_TOP_EVENT } from 'constants/layout';

const SCROLL_POSITION_TO_SHOW_BUTTON_IN_PX = 310;
const SCROLL_POSITION_TO_SHOW_BUTTON_AFTER_LG_IN_PX = 660;

const ScrollToTopButton = ({ className, gaEventCategory = null }) => {
  const { isLg } = useMediaQuery();
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty(SCROLL_TO_TOP_CSS_VAR, '56px');
    window.dispatchEvent(new CustomEvent(SCROLL_TO_TOP_EVENT));
    return () => {
      document.documentElement.style.removeProperty(SCROLL_TO_TOP_CSS_VAR);
      window.dispatchEvent(new CustomEvent(SCROLL_TO_TOP_EVENT));
    };
  }, []);

  useScrollPosition(
    ({ currPos }) => {
      setOpen(
        currPos.y >=
          (isLg
            ? SCROLL_POSITION_TO_SHOW_BUTTON_AFTER_LG_IN_PX
            : SCROLL_POSITION_TO_SHOW_BUTTON_IN_PX)
      );
    },
    { deps: [isLg] }
  );

  const onClick = () => {
    if (gaEventCategory) {
      sendEvent({ action: 'go_to_top', category: gaEventCategory });
    }

    scrollToTop();
  };

  return (
    <Button
      className={twMerge(
        'sticky bottom-[calc(var(--navbar-height)_+_var(--navbar-space))] right-4 z-10 ml-auto lg:bottom-4',
        isOpen ? 'opacity-1 visible' : 'invisible opacity-0',
        className
      )}
      icon={<Icon name="keyboard-arrow-up" />}
      size="size2"
      type="primary"
      onClick={onClick}
    />
  );
};

ScrollToTopButton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string,
};

export default ScrollToTopButton;
